<template>
  <div>
    <template v-if="!loading">
      <app-empty-message
        v-if="count !== undefined"
        :count="count"
        :heading="heading"
        :is-empty-boxed="isEmptyBoxed"
      >
        <slot></slot>

        <template #message>
          <slot name="message"></slot>
        </template>
      </app-empty-message>

      <template v-else>
        <slot></slot>
      </template>
    </template>

    <b-loading :active="loading" :is-full-page="false"></b-loading>
  </div>
</template>

<script>
export default {
  name: "AppLoadingSection",
  props: {
    loading: {
      type: Boolean,
      required: true
    },
    count: {
      type: [
        Number,
        undefined
      ],
    },
    heading: {
      type: [
        String,
        undefined
      ],
      default: ''
    },
    isEmptyBoxed: {
      type: Boolean,
      default: false,
    },
  }
};
</script>

<style lang="scss" scoped>
@import "../../styles/variables/variables";

</style>
